import React,{ Component } from 'react';

const Error = ({text}) => {
    return (
    	<div className="alert alert-danger text-center">	
    		{text}
    	</div>
    );
}

export default Error;